<template>
    <div class="vrm-language">
        <div class="container">
            <h1 class="vrm-page-title">{{ $t('language.SelectLanguage') }}</h1>
            <div class="vrm-form vrm-language__language-table">
                <div class="vrm-language__language-group">
                    <div
                        v-for="language in listedLanguages"
                        :key="language"
                        :class="{
                            'vrm-language__language-item--selected': language === selectedLanguage,
                            'vrm-language__language-item--current': language === currentLanguage,
                        }"
                        class="vrm-language__language-item"
                        @click="() => setLanguage(language)"
                    >
                        <div class="vrm-language__label">
                            <div class="sg-caption">
                                {{ getLanguageTitle(language) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sg-btn__container sg-btn__container--align-right">
                <button type="button" class="sg-btn sg-site" @click="updateSavedLanguage">
                    {{ $t('common.confirm_deletion_cancel', { i18nFallback: 'Cancel' }) }}
                </button>
                <button type="button" class="sg-btn sg-blue" @click="saveLanguage">
                    {{ $t('common.save', { i18nFallback: 'Save {itemName}' }) }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { localeMeta } from '@/languages/meta';
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
@Component({ components: {} })
@AngularRoute('base.profile.language', '/language', { slot: 'body' })
export default class Language extends Vue {
    @ngInject()
    VrmLangService;

    languages = [];
    selectedLanguage = 'en';
    currentLanguage = 'en';
    async mounted() {
        this.languages = this.listedLanguages;
        this.updateSavedLanguage();
    }

    updateSavedLanguage() {
        this.VrmLangService.getLang().then(lang => {
            this.selectedLanguage = lang;
            this.currentLanguage = lang;
        });
    }

    get listedLanguages() {
        return localeMeta.languages.map(l => l.code);
    }

    getLanguageTitle(code) {
        const lang = localeMeta.getByCode(code);
        return lang && lang.label ? lang.label : this.$t(`language.${code}`);
    }

    setLanguage(lang) {
        this.selectedLanguage = lang;
    }

    saveLanguage() {
        this.VrmLangService.setLang(this.selectedLanguage).then(() => {
            this.currentLanguage = this.selectedLanguage;
        });
    }
}
</script>
